var Scope;
(function (Scope) {
  Scope["Serlo"] = "serlo.org";
  Scope["Serlo_De"] = "serlo.org:de";
  Scope["Serlo_En"] = "serlo.org:en";
  Scope["Serlo_Es"] = "serlo.org:es";
  Scope["Serlo_Fr"] = "serlo.org:fr";
  Scope["Serlo_Hi"] = "serlo.org:hi";
  Scope["Serlo_Ta"] = "serlo.org:ta";
})(Scope || (Scope = {}));
var Instance;
(function (Instance) {
  Instance["De"] = "de";
  Instance["En"] = "en";
  Instance["Es"] = "es";
  Instance["Fr"] = "fr";
  Instance["Hi"] = "hi";
  Instance["Ta"] = "ta";
})(Instance || (Instance = {}));
function formatScope(scope) {
  if (scope === 'Serlo') return Scope.Serlo;
  var scopeIdentifier = scope.split('_')[1].toLowerCase();
  return "serlo.org:" + scopeIdentifier;
}
function instanceToScope(instance) {
  return instance === null ? Scope.Serlo : "serlo.org:" + instance;
}
function scopeToInstance(scope) {
  return scope === Scope.Serlo ? null : scope.split(':')[1];
}
var Permission;
(function (Permission) {
  Permission["Entity_CheckoutRevision"] = "entity:checkoutRevision";
  Permission["Entity_RejectRevision"] = "entity:rejectRevision";
  Permission["Entity_UpdateLicense"] = "entity:updateLicense";
  Permission["Entity_AddChild"] = "entity:addChild";
  Permission["Entity_RemoveChild"] = "entity:removeChild";
  Permission["Entity_OrderChildren"] = "entity:orderChildren";
  Permission["File_Create"] = "file:create";
  Permission["File_Delete"] = "file:delete";
  Permission["License_Create"] = "license:create";
  Permission["License_Delete"] = "license:delete";
  Permission["License_Set"] = "license:set";
  Permission["Notification_SetState"] = "notification:setState";
  Permission["Page_CheckoutRevision"] = "page:checkoutRevision";
  Permission["Page_RejectRevision"] = "page:rejectRevision";
  Permission["Page_Set"] = "page:set";
  Permission["Subscription_Set"] = "subscription:set";
  Permission["TaxonomyTerm_Change"] = "taxonomyTerm:change";
  Permission["TaxonomyTerm_RemoveChild"] = "taxonomyTerm:removeChild";
  Permission["TaxonomyTerm_OrderChildren"] = "taxonomyTerm:orderChildren";
  Permission["Ai_ExecutePrompt"] = "ai:executePrompt";
  Permission["TaxonomyTerm_Set"] = "taxonomyTerm:set";
  Permission["Thread_CreateThread"] = "thread:createThread";
  Permission["Thread_CreateComment"] = "thread:createComment";
  Permission["Thread_DeleteThread"] = "thread:deleteThread";
  Permission["Thread_DeleteComment"] = "thread:deleteComment";
  Permission["User_AddRole"] = "user:addRole";
  Permission["User_DeleteBot"] = "user:deleteBot";
  Permission["User_DeleteRegularUser"] = "user:deleteRegularUser";
  Permission["User_GetUsersByRole"] = "user:getUsersByRole";
  Permission["User_RemoveRole"] = "user:removeRole";
  Permission["User_SetEmail"] = "user:setEmail";
  Permission["Thread_SetThreadArchived"] = "thread:setThreadArchived";
  Permission["Thread_SetThreadState"] = "thread:setThreadState";
  Permission["Thread_SetCommentState"] = "thread:setCommentState";
  Permission["Thread_SetThreadStatus"] = "thread:setThreadStatus";
  Permission["Uuid_Create_Entity"] = "uuid:create:entity";
  Permission["Uuid_Create_EntityRevision"] = "uuid:create:entityRevision";
  Permission["Uuid_Create_Page"] = "uuid:create:page";
  Permission["Uuid_Create_PageRevision"] = "uuid:create:pageRevision";
  Permission["Uuid_Create_TaxonomyTerm"] = "uuid:create:taxonomyTerm";
  Permission["Uuid_Delete_Entity"] = "uuid:delete:entity";
  Permission["Uuid_Delete_EntityRevision"] = "uuid:delete:entityRevision";
  Permission["Uuid_Delete_Page"] = "uuid:delete:page";
  Permission["Uuid_Delete_PageRevision"] = "uuid:delete:pageRevision";
  Permission["Uuid_Delete_TaxonomyTerm"] = "uuid:delete:taxonomyTerm";
  Permission["Uuid_SetState_Entity"] = "uuid:setState:entity";
  Permission["Uuid_SetState_EntityRevision"] = "uuid:setState:entityRevision";
  Permission["Uuid_SetState_Page"] = "uuid:setState:page";
  Permission["Uuid_SetState_PageRevision"] = "uuid:setState:pageRevision";
  Permission["Uuid_SetState_TaxonomyTerm"] = "uuid:setState:taxonomyTerm";
})(Permission || (Permission = {}));
function createPermissionGuard(permission) {
  return function (scope) {
    return function (authorizationPayload) {
      var _authorizationPayload;
      return ((_authorizationPayload = authorizationPayload[scope]) == null ? void 0 : _authorizationPayload.includes(permission)) === true;
    };
  };
}
var Entity = {
  checkoutRevision: /*#__PURE__*/createPermissionGuard(Permission.Entity_CheckoutRevision),
  rejectRevision: /*#__PURE__*/createPermissionGuard(Permission.Entity_RejectRevision),
  updateLicense: /*#__PURE__*/createPermissionGuard(Permission.Entity_UpdateLicense),
  addChild: /*#__PURE__*/createPermissionGuard(Permission.Entity_AddChild),
  removeChild: /*#__PURE__*/createPermissionGuard(Permission.Entity_RemoveChild),
  orderChildren: /*#__PURE__*/createPermissionGuard(Permission.Entity_OrderChildren)
};
var Ai = {
  executePrompt: /*#__PURE__*/createPermissionGuard(Permission.Ai_ExecutePrompt)
};
var File = {
  create: /*#__PURE__*/createPermissionGuard(Permission.File_Create),
  "delete": /*#__PURE__*/createPermissionGuard(Permission.File_Delete)
};
var License = {
  create: /*#__PURE__*/createPermissionGuard(Permission.License_Create),
  "delete": /*#__PURE__*/createPermissionGuard(Permission.License_Delete),
  set: /*#__PURE__*/createPermissionGuard(Permission.License_Set)
};
var Notification = {
  setState: /*#__PURE__*/createPermissionGuard(Permission.Notification_SetState)
};
var Page = {
  checkoutRevision: /*#__PURE__*/createPermissionGuard(Permission.Page_CheckoutRevision),
  rejectRevision: /*#__PURE__*/createPermissionGuard(Permission.Page_RejectRevision),
  set: /*#__PURE__*/createPermissionGuard(Permission.Page_Set)
};
var Subscription = {
  set: /*#__PURE__*/createPermissionGuard(Permission.Subscription_Set)
};
var TaxonomyTerm = {
  change: /*#__PURE__*/createPermissionGuard(Permission.TaxonomyTerm_Change),
  removeChild: /*#__PURE__*/createPermissionGuard(Permission.TaxonomyTerm_RemoveChild),
  orderChildren: /*#__PURE__*/createPermissionGuard(Permission.TaxonomyTerm_OrderChildren),
  set: /*#__PURE__*/createPermissionGuard(Permission.TaxonomyTerm_Set)
};
var Thread = {
  createThread: /*#__PURE__*/createPermissionGuard(Permission.Thread_CreateThread),
  createComment: /*#__PURE__*/createPermissionGuard(Permission.Thread_CreateComment),
  deleteThread: /*#__PURE__*/createPermissionGuard(Permission.Thread_DeleteThread),
  deleteComment: /*#__PURE__*/createPermissionGuard(Permission.Thread_DeleteComment),
  setThreadArchived: /*#__PURE__*/createPermissionGuard(Permission.Thread_SetThreadArchived),
  setThreadState: /*#__PURE__*/createPermissionGuard(Permission.Thread_SetThreadState),
  setThreadStatus: /*#__PURE__*/createPermissionGuard(Permission.Thread_SetThreadStatus),
  setCommentState: /*#__PURE__*/createPermissionGuard(Permission.Thread_SetCommentState)
};
var User = {
  addRole: /*#__PURE__*/createPermissionGuard(Permission.User_AddRole),
  deleteBot: /*#__PURE__*/createPermissionGuard(Permission.User_DeleteBot),
  deleteRegularUser: /*#__PURE__*/createPermissionGuard(Permission.User_DeleteRegularUser),
  getUsersByRole: /*#__PURE__*/createPermissionGuard(Permission.User_GetUsersByRole),
  removeRole: /*#__PURE__*/createPermissionGuard(Permission.User_RemoveRole),
  setEmail: /*#__PURE__*/createPermissionGuard(Permission.User_SetEmail)
};
var Uuid = {
  create: function create(type) {
    return function (scope) {
      return function (authorizationPayload) {
        switch (type) {
          case 'Entity':
            return checkPermission(Permission.Uuid_Create_Entity);
          case 'EntityRevision':
            return checkPermission(Permission.Uuid_Create_EntityRevision);
          case 'Page':
            return checkPermission(Permission.Uuid_Create_Page);
          case 'PageRevision':
            return checkPermission(Permission.Uuid_Create_PageRevision);
          case 'TaxonomyTerm':
            return checkPermission(Permission.Uuid_Create_TaxonomyTerm);
          case 'User':
            return false;
          default:
            return false;
        }
        function checkPermission(permission) {
          return createPermissionGuard(permission)(scope)(authorizationPayload);
        }
      };
    };
  },
  "delete": function _delete(type) {
    return function (scope) {
      return function (authorizationPayload) {
        switch (type) {
          case 'Entity':
            return checkPermission(Permission.Uuid_Delete_Entity);
          case 'EntityRevision':
            return checkPermission(Permission.Uuid_Delete_EntityRevision);
          case 'Page':
            return checkPermission(Permission.Uuid_Delete_Page);
          case 'PageRevision':
            return checkPermission(Permission.Uuid_Delete_PageRevision);
          case 'TaxonomyTerm':
            return checkPermission(Permission.Uuid_Delete_TaxonomyTerm);
          case 'User':
            return false;
          default:
            return false;
        }
        function checkPermission(permission) {
          return createPermissionGuard(permission)(scope)(authorizationPayload);
        }
      };
    };
  },
  setState: function setState(type) {
    return function (scope) {
      return function (authorizationPayload) {
        switch (type) {
          case 'Entity':
            return checkPermission(Permission.Uuid_SetState_Entity);
          case 'EntityRevision':
            return checkPermission(Permission.Uuid_SetState_EntityRevision);
          case 'Page':
            return checkPermission(Permission.Uuid_SetState_Page);
          case 'PageRevision':
            return checkPermission(Permission.Uuid_SetState_PageRevision);
          case 'TaxonomyTerm':
            return checkPermission(Permission.Uuid_SetState_TaxonomyTerm);
          case 'User':
            return false;
          default:
            return false;
        }
        function checkPermission(permission) {
          return createPermissionGuard(permission)(scope)(authorizationPayload);
        }
      };
    };
  }
};

export { Ai, Entity, File, License, Notification, Page, Permission, Scope, Subscription, TaxonomyTerm, Thread, User, Uuid, formatScope, instanceToScope, scopeToInstance };
//# sourceMappingURL=authorization.esm.js.map
